import axios from "../services/axios";

import { getErrorMessageFromAxiosError } from "../utils/axiosUtils";
import { toIsoString } from "../utils/date";
import { addFlashMessage } from "./FlashMessagesAction";
import { setTotal as setTotalAction } from "./advancedListActions";

import * as api from "../constants/api";

export const GET_ELSPARKSYKKELGEBYR_SUCCESS = "GET_ELSPARKSYKKELGEBYR_SUCCESS";

export function getElsparksykkelGebyr(params, page, count) {
  return async (dispatch) => {
    dispatch(setTotalAction("elsparksykkelgebyr", 0));
    dispatch({
      type: GET_ELSPARKSYKKELGEBYR_SUCCESS,
      payload: [],
    });

    if (
      !params.ileggelsesnummer &&
      !params.tjenestenummer &&
      !params.fraDato &&
      !params.tilDato &&
      !params.aktorId
    ) {
      dispatch(
        addFlashMessage({
          type: "error",
          text: "Må filtrere på minst én egenskap",
        }),
      );

      return Promise.reject();
    }

    return axios
      .get(api.GET_ILEGGELSER_URL, {
        params: {
          aktorId: params.aktorId,
          ileggelsesnummer: params.ileggelsesnummer,
          tjenestenummer: params.tjenestenummer,
          fraDato: params.fraDato && toIsoString(params.fraDato),
          tilDato: params.tilDato && toIsoString(params.tilDato),
          isElsparksykkelGebyr: params.isElsparksykkelGebyr,
          isMakulert: params.isMakulert,
          include: params.include,

          orderBy: "descending",
          page: page,
          pageSize: count,
        },
        paramsSerializer: {
          indexes: null,
        },
      })
      .then((response) => {
        dispatch(
          setTotalAction(
            "elsparksykkelGebyr",
            JSON.parse(response.headers["x-pagination"]).Total,
          ),
        );
        dispatch({
          type: GET_ELSPARKSYKKELGEBYR_SUCCESS,
          payload: response.data.result,
        });
        return Promise.resolve(response);
      })
      .catch((error) => {
        let errorMessage = getErrorMessageFromAxiosError(error);
        dispatch(addFlashMessage({ type: "error", text: errorMessage }));
        return Promise.reject(error);
      });
  };
}
